import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  isSidebarOpen = signal<boolean>(false);
  isSidebarCollapsed = signal<boolean>(false);

  toggleSidebar() {
    this.isSidebarOpen.update((v) => !v);
  }

  toggleSidebarCollapse() {
    this.isSidebarCollapsed.update((v) => !v);
  }

  closeSidebar() {
    this.isSidebarOpen.set(false);
  }
}
